import React from 'react';
import { Text, makeStyles } from '@fluentui/react-components';
import { Document } from '@si/fib-icons';

const usePageHeaderStyles = makeStyles({
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '15px',
        paddingBottom: '12px',
        borderBottom: '1px solid #00000026',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    titleSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '42px',
        height: '42px',
        borderRadius: '100px',
        backgroundColor: '#B5D9D94D',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: '#B5D9D980',
        },
    },
    titleText: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#424242',
    },
    descriptionText: {
        fontSize: '14px',
        fontWeight: '400',
        color: '#666666',
    },
});

interface PageHeaderProps {
    title: string;
    description: string;
    icon?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, description, icon }) => {
    const styles = usePageHeaderStyles();

    return (
        <div className={styles.headerContainer}>
            <div className={styles.titleContainer}>
                <div className={styles.iconContainer}>
                    {icon || <Document size={20} />}
                </div>
                <div className={styles.titleSection}>
                    <Text className={styles.titleText}>
                        {title}
                    </Text>
                    <Text className={styles.descriptionText}>
                        {description}
                    </Text>
                </div>
            </div>
        </div>
    );
};
